import { Form, Button, Row, Col, Alert, Modal, Badge } from 'react-bootstrap';
import React, { useEffect, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import axiosInstance from '../general/axiosInstance';
import { setIsLoading } from '../general/actions';
import { default as Catalog } from '../catalog/products';
import { currencyFormater, LOGO_IMG_PATH } from '../general/utils';
import { useParams, useNavigate, Link } from 'react-router-dom';
import OrderDetails from './orderDetails';
import AlertModal from '../general/alertModal';
import Print from '../order/print';
import { C } from '../general/colors';

// Ciudades disponibles para sub-localidades
const KNOWN_CITIES = [
    { id: '05001', name: 'Medellín' },
    { id: '11001', name: 'Bogotá D.C.' },
];

// Dot de completitud por sección
function SectionDot({ ok }) {
    return (
        <span style={{
            marginLeft: 'auto', width: 18, height: 18, borderRadius: '50%',
            background: ok ? '#dcfce7' : '#f1f5f9',
            border: `1px solid ${ok ? '#86efac' : '#cbd5e1'}`,
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 10, color: ok ? '#16a34a' : '#94a3b8', flexShrink: 0,
        }}>
            <i className={ok ? 'fa fa-check' : 'fa fa-circle-o'} />
        </span>
    );
}

function OrderCreate(props) {
    const navigate = useNavigate();
    const { setIsLoading, roles, readonly, is_provider, organization } = props;
    const { agreementSel, productSel } = useParams();

    const [preselectedProduct, setPreselectedProduct] = useState(productSel);
    const [orderId, setOrderId] = useState(props.orderId ? props.orderId : '');
    const [createdAt, setCreatedAt] = useState('');
    const [minHoursDeliver, setMinHoursDeliver] = useState(12);

    const [idPrint, setIdPrint] = useState(false);
    const [showPrint, setShowPrint] = useState(false);
    const [showProductsModal, setShowProductsModal] = useState(false);

    const [initFundVal, setInitFundVal] = useState(null);
    const [totalOrder, setTotalOrder] = useState(0);
    const orderFundVal = useMemo(() => (initFundVal || 0) - totalOrder, [initFundVal, totalOrder]);

    const [itemsToDelete, setItemsToDelete] = useState([]);

    const [alertModalShow, setAlertModalShow] = useState(false);
    const [alertModalMsg, setAlertModalMsg] = useState('');
    const [alertModalType, setAlertModalType] = useState('');
    const [alertModalOnConfirm, setAlertModalOnConfirm] = useState(null);
    const [alertModalOnClose, setAlertModalOnClose] = useState(null);

    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('warning');

    const [agreements, setAgreements] = useState([]);
    const [funds, setFunds] = useState([]);

    const addProduct = (item) => {
        const itemExist = details.some(i => i.id === item.id);
        if (itemExist) {
            setAlertModalMsg('El producto seleccionado ya está en el pedido');
            setAlertModalShow(true);
            setShowProductsModal(false);
            return;
        }
        item['quantity'] = item['quantity'] || 1;
        setDetails([...details, item]);
        setShowProductsModal(false);
    };

    const getDetailsData = () => {
        return details.map(item => {
            const detail = {
                product_id: item.id,
                fund_id: fund,
                quantity: item.quantity,
                price: item.price,
                total_amount: item.price * item.quantity,
                taxes: item.taxes,
                notes: '',
            };
            if (item.id_detail) detail.id = item.id_detail;
            if (orderId) detail.order_id = orderId;
            return detail;
        });
    };

    const setInitialState = (index) => {
        if (index === 'order_status') {
            return props.orderData && props.orderData[index] ? props.orderData[index].description : '';
        }
        if (!props.orderData && index === 'details') return [];
        if (!props.orderData) return '';
        if (index === 'details') return props.orderData.order_detail;
        return props.orderData[index] || '';
    };

    const [fund, setFund] = useState(setInitialState('fund_id'));
    const [agreement, setAgreement] = useState(setInitialState('agreement_id'));
    const [status, setStatus] = useState(setInitialState('order_status'));
    const [personReceiving, setPersonReceiving] = useState(setInitialState('delivery_person_receiving'));
    const [personReceivingPhone, setPersonReceivingPhone] = useState(setInitialState('delivery_phone'));
    const [newCreatedAt, setNewCreatedAt] = useState(null);
    const [deliveryDate, setDeliveryDate] = useState(setInitialState('delivery_date'));
    const [deliveryTime, setDeliveryTime] = useState(setInitialState('delivery_time'));
    const [deliveryAddress, setDeliveryAddress] = useState(setInitialState('delivery_address'));
    const [deliveryEvent, setDeliveryEvent] = useState(setInitialState('delivery_event_name'));
    const [notes, setNotes] = useState(setInitialState('notes'));
    const [details, setDetails] = useState(setInitialState('details'));

    // Sub-localidad
    const [cityId, setCityId] = useState(!props.orderId ? (organization?.city_id || '') : '');
    const [subLocalityId, setSubLocalityId] = useState(setInitialState('sub_locality_id'));
    const [subLocalities, setSubLocalities] = useState([]);
    const [subLocalityLabel, setSubLocalityLabel] = useState('Sector/Barrio');
    const [loadingSubLocalities, setLoadingSubLocalities] = useState(false);

    const loadAgreements = () => {
        setIsLoading(true);
        axiosInstance.get('/agreements/current-user')
            .then(res => {
                setIsLoading(false);
                const activeAgreements = res.data.filter(a => a.is_active);
                formatFunds(activeAgreements);
                setAgreements(activeAgreements);
            })
            .catch(err => { setIsLoading(false); console.log(err); });
    };

    const loadSubLocalities = async (cId) => {
        if (!cId) { setSubLocalities([]); setSubLocalityLabel('Sector/Barrio'); return; }
        setLoadingSubLocalities(true);
        try {
            const res = await axiosInstance.get('/v1/sub-localities', { params: { city_id: cId } });
            setSubLocalities(res.data.data || []);
            setSubLocalityLabel(res.data.meta?.label_type || 'Sector/Barrio');
        } catch (err) {
            console.error('Error cargando sub-localidades:', err);
        } finally {
            setLoadingSubLocalities(false);
        }
    };

    const orderFields = () => ({
        agreement_id: agreement,
        delivery_date: deliveryDate,
        created_at: newCreatedAt ? newCreatedAt + ' ' + createdAt.split(' ')[1] : null,
        delivery_time: deliveryTime,
        delivery_address: deliveryAddress,
        delivery_person_receiving: personReceiving,
        delivery_phone: personReceivingPhone,
        delivery_event_name: deliveryEvent,
        sub_locality_id: subLocalityId || null,
        fund_id: fund,
        notes,
        details: getDetailsData(),
        items_delete: itemsToDelete,
    });

    const updateOrder = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.put(`/orders/${orderId}`, orderFields());
            setDetailsId(response.data);
            setAlertModalOnConfirm(null);
            setAlertModalOnClose(null);
            setAlertModalType('');
            setAlertModalShow(true);
            setAlertModalMsg('Pedido actualizado correctamente');
            setStatus('Creado');
            setNewCreatedAt('');
            setCreatedAt(newCreatedAt ? newCreatedAt + ' ' + createdAt.split(' ')[1] : createdAt);
        } catch (error) {
            setAlertModalType('danger');
            setAlertModalShow(true);
            setAlertModalMsg(error?.response?.data?.message || error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const setDetailsId = (data) => {
        setDetails(details.map(x => {
            if (data.details[x.id]) return { ...x, id_detail: data.details[x.id] };
            return { ...x };
        }));
    };

    const createOrder = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.post(`/orders`, orderFields());
            const newId = response.data.id;
            setOrderId(newId);
            setDetailsId(response.data);
            setAlertModalOnConfirm(null);
            setAlertModalOnClose(() => () => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setIdPrint(newId);
                setShowPrint(true);
            });
            setAlertModalType('');
            setAlertModalShow(true);
            setAlertModalMsg('¡Pedido creado! Número asignado: ' + newId);
        } catch (error) {
            setAlertModalType('danger');
            setAlertModalShow(true);
            const backendMsg = error?.response?.data?.message || '';
            if (backendMsg.indexOf('Duplicate') > 0) {
                setAlertModalMsg('El pedido ya existe');
            } else if (backendMsg.indexOf('Fund is inactive') > 0) {
                setAlertModalMsg('El fondo seleccionado está inactivo');
            } else {
                setAlertModalMsg(backendMsg || error.message);
            }
        } finally {
            setIsLoading(false);
        }
    };

    const formatFunds = (data) => {
        if (fund) return getFundById(fund);
        const list = [];
        data.forEach(agr => {
            agr.fund.forEach(item => {
                if (item.user_fund.length) {
                    list.push({
                        id: item.id,
                        name: item.name,
                        available: item.available,
                        ext_id: item.ext_id,
                        agreement_id: item.agreement_id,
                        agreement_ext_id: agr.ext_id,
                        is_active: item.is_active,
                    });
                }
            });
        });
        setFunds(list);
    };

    const getFundById = async (id) => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.get('funds', id);
            setFunds(response.data);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const deleleteOrder = async (e, confirmed) => {
        if (!confirmed) {
            setAlertModalShow(true);
            setAlertModalMsg('¿Estás seguro de anular el pedido ' + orderId + '? Esta acción no se puede deshacer.');
            setAlertModalOnConfirm(() => () => { deleleteOrder(null, true); });
            return;
        }
        setIsLoading(true);
        try {
            await axiosInstance.delete(`/orders/${orderId}`);
            setAlertModalOnConfirm(null);
            setAlertModalType('');
            setAlertModalShow(true);
            setAlertModalMsg('Pedido ' + orderId + ' anulado correctamente');
            setAlertModalOnClose(() => () => { navigate('/main'); });
        } catch (error) {
            setAlertModalType('danger');
            setAlertModalShow(true);
            setAlertModalMsg(error?.response?.data?.message || error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const saveOrder = (e, confirmed) => {
        e.preventDefault();
        if (!confirmed) {
            const arrDate = deliveryDate.split('-');
            const date = `${arrDate[2]}/${arrDate[1]}/${arrDate[0]}`;
            setAlertModalType('');
            setAlertModalShow(true);
            setAlertModalMsg(`El pedido será entregado el día ${date} a las ${deliveryTime} horas. ¿Es correcto?`);
            setAlertModalOnConfirm(() => () => { saveOrder(e, true); });
            return;
        }
        if (!isValidFormData()) {
            setAlertModalType('danger');
            setAlertModalShow(true);
            setAlertModalMsg('El plazo mínimo de entrega es de ' + minHoursDeliver + ' horas');
            return;
        }
        if (orderId) updateOrder(); else createOrder();
    };

    const getHoursToDeliver = () => {
        if (!deliveryDate || !deliveryTime) return NaN;
        const specificDate = new Date(`${deliveryDate}T${deliveryTime}`);
        if (isNaN(specificDate.getTime())) return NaN;
        return (specificDate.getTime() - Date.now()) / (1000 * 60 * 60);
    };

    const isValidFormData = () => {
        setMessageType('warning');
        if (!agreement) { setMessage('Contrato es obligatorio'); return false; }
        if (!deliveryDate) { setMessage('Fecha de entrega es obligatoria'); return false; }
        if (!deliveryTime) { setMessage('Hora de entrega es obligatoria'); return false; }
        const hours = getHoursToDeliver();
        if ((isNaN(hours) || hours < minHoursDeliver) && !(roles.includes('provider_order') || roles.includes('customer_admin'))) {
            setMessage('El plazo mínimo de entrega es de ' + minHoursDeliver + ' horas');
            return false;
        }
        if (!fund) { setMessage('Fondo presupuestal es obligatorio'); return false; }
        if (!deliveryAddress) { setMessage('Dirección de entrega es obligatoria'); return false; }
        if (!personReceiving) { setMessage('Persona que recibe es obligatorio'); return false; }
        if (!personReceivingPhone) { setMessage('Teléfono de quien recibe es obligatorio'); return false; }
        if (!details.length) { setMessage('Debes agregar al menos un producto'); return false; }
        if (details.every(d => parseInt(d.quantity) <= 0)) { setMessage('Debes agregar al menos un producto'); return false; }
        setMessage('');
        return true;
    };

    useEffect(() => { if (!agreements.length) loadAgreements(); }, []);
    useEffect(() => { isValidFormData(); }, [agreement, deliveryDate, deliveryTime, fund, deliveryAddress, personReceiving, personReceivingPhone, details]);
    useEffect(() => {
        if (agreements && !orderId) setDetails([]);
        if (agreement && agreements.length) {
            const sel = agreements.find(x => x.id === parseInt(agreement));
            if (sel) setMinHoursDeliver(sel.min_hours_deliver ?? 24);
        }
    }, [agreement, agreements]);
    useEffect(() => {
        if (agreementSel && agreements.length) {
            setAgreement(agreementSel);
            const sel = agreements.find(a => a.id === parseInt(agreementSel));
            if (sel) setMinHoursDeliver(sel.min_hours_deliver ?? 24);
        }
    }, [agreements, agreementSel]);
    useEffect(() => { if (agreement && preselectedProduct) setShowProductsModal(true); }, [agreement, preselectedProduct, agreements]);
    useEffect(() => {
        if (cityId) loadSubLocalities(cityId);
        else { setSubLocalities([]); setSubLocalityLabel('Sector/Barrio'); }
    }, [cityId]);
    useEffect(() => { isValidFormData(); }, [minHoursDeliver]);
    useEffect(() => {
        if (funds.length) {
            const available = parseFloat(funds.filter(x => x.id == parseInt(fund)).map(f => f.available)[0]) || 0;
            if (initFundVal === null) setInitFundVal(available + totalOrder);
        }
    }, [funds, totalOrder, fund, agreement]);
    useEffect(() => {
        setOrderId(props.orderId);
        setCreatedAt(props.orderData ? props.orderData.created_at : '');
        setStatus(setInitialState('order_status'));
        setFund(setInitialState('fund_id'));
        setAgreement(setInitialState('agreement_id'));
        setPersonReceiving(setInitialState('delivery_person_receiving'));
        setPersonReceivingPhone(setInitialState('delivery_phone'));
        setDeliveryDate(setInitialState('delivery_date'));
        setDeliveryTime(setInitialState('delivery_time'));
        setDeliveryAddress(setInitialState('delivery_address'));
        setDeliveryEvent(setInitialState('delivery_event_name'));
        setNotes(setInitialState('notes'));
        setDetails(setInitialState('details'));
        setSubLocalityId(setInitialState('sub_locality_id'));
        setCityId(!props.orderId ? (organization?.city_id || '') : '');
        setSubLocalities([]);
        setSubLocalityLabel('Sector/Barrio');
    }, [props.orderId]);
    useEffect(() => {
        if (!readonly && initFundVal && orderFundVal < 0) {
            setMessageType('danger');
            setMessage('Presupuesto superado en ' + currencyFormater(orderFundVal));
            setAlertModalType('danger');
            setAlertModalShow(true);
            setAlertModalMsg('Presupuesto superado en ' + currencyFormater(orderFundVal));
        }
    }, [orderFundVal, initFundVal]);
    useEffect(() => {
        if (orderId && typeof props.setOrderId === 'function') props.setOrderId(orderId);
    }, [orderId]);

    // Al editar un pedido con sub_locality_id ya guardado, auto-detecta la ciudad
    // y precarga el listado correcto para que el select quede poblado.
    useEffect(() => {
        if (!subLocalityId || cityId) return;
        Promise.all(
            KNOWN_CITIES.map(c =>
                axiosInstance
                    .get('/v1/sub-localities', { params: { city_id: c.id } })
                    .then(r => ({ cityId: c.id, data: r.data.data || [], meta: r.data.meta || {} }))
                    .catch(() => null)
            )
        ).then(results => {
            for (const result of results) {
                if (!result) continue;
                const found = result.data.find(s => s.id === parseInt(subLocalityId));
                if (found) {
                    setCityId(result.cityId);
                    setSubLocalities(result.data);
                    setSubLocalityLabel(result.meta.label_type || 'Sector/Barrio');
                    break;
                }
            }
        });
    }, [subLocalityId]); // eslint-disable-line react-hooks/exhaustive-deps

    const pageTitle = !orderId && !readonly ? 'Crear Pedido' : orderId && !readonly ? 'Modificar Pedido' : 'Consultar Pedido';

    const fundUsedPct = initFundVal > 0 ? Math.min(100, (totalOrder / initFundVal) * 100) : 0;
    const fundBarColor = fundUsedPct >= 90 ? C.danger : fundUsedPct >= 60 ? C.warning : C.success;

    // Estado de completitud por sección
    const done = {
        contract: !!(agreement && deliveryDate && deliveryTime),
        fund:     !!fund,
        delivery: !!(deliveryAddress && personReceiving && personReceivingPhone),
        products: details.length > 0,
    };

    // Indicador de plazo mínimo
    const hoursLeft   = deliveryDate && deliveryTime ? getHoursToDeliver() : null;
    const hoursValid  = hoursLeft !== null && !isNaN(hoursLeft);
    const canOverride = roles.includes('provider_order') || roles.includes('customer_admin');
    const deadlineOk  = !hoursValid || hoursLeft >= minHoursDeliver || canOverride;

    return (
        <>
            {/* ── Header ── */}
            <div className="order-page-header">
                <div>
                    <div className="order-page-title">
                        {agreement && (
                            <img
                                height="32"
                                src={LOGO_IMG_PATH + 'agreement-' + agreement + '.png'}
                                className="rounded" alt=""
                                style={{ marginRight: 4 }}
                            />
                        )}
                        {pageTitle}
                        {orderId && <Badge bg="secondary" style={{ fontSize: 14 }}># {orderId}</Badge>}
                    </div>
                    {orderId && (
                        <div className="order-meta-badges">
                            <span className="order-meta-badge"><i className="fa fa-calendar-o" /> {createdAt}</span>
                            <span className="order-meta-badge"><i className="fa fa-tag" /> {status}</span>
                        </div>
                    )}
                </div>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    {orderId && !readonly && (
                        <Button variant="outline-danger" size="sm" onClick={deleleteOrder}>
                            <i className="fa fa-ban" /> Anular
                        </Button>
                    )}
                    {orderId && (
                        <Button variant="outline-secondary" size="sm" onClick={() => { setIdPrint(orderId); setShowPrint(true); }}>
                            <i className="fa fa-print" /> Imprimir
                        </Button>
                    )}
                </div>
            </div>

            {/* Banner guía — solo en creación, antes de completar */}
            {!orderId && !readonly && !done.contract && (
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, background: 'rgba(37,99,235,0.05)', border: '1px solid rgba(37,99,235,0.15)', borderRadius: 12, padding: '12px 16px', marginBottom: 14 }}>
                    <i className="fa fa-lightbulb-o" style={{ color: 'var(--abi-primary)', fontSize: 18, marginTop: 1, flexShrink: 0 }} />
                    <div style={{ fontSize: 13, color: 'var(--abi-text)', lineHeight: 1.6 }}>
                        <strong>Pasos para crear un pedido:</strong>
                        {' '}Selecciona el contrato y la fecha de entrega → elige el fondo presupuestal → completa los datos de entrega → agrega los productos.
                    </div>
                </div>
            )}

            <Form>
                {/* ── Sección 1: Contrato y fechas ── */}
                <div className="order-section">
                    <div className="order-section-header">
                        <i className="fa fa-file-text-o" /> Contrato y Fechas de Entrega
                        {!readonly && <SectionDot ok={done.contract} />}
                    </div>
                    <div className="order-section-body">
                        <Row>
                            <Col md={8} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Contrato</Form.Label>
                                    <Form.Select
                                        disabled={readonly || orderId}
                                        value={agreement}
                                        onChange={(e) => { setAgreement(e.target.value); setFund(''); setInitFundVal(null); }}
                                    >
                                        <option value="">— Selecciona un contrato —</option>
                                        {agreements && agreements.map(item => (
                                            <option key={'orderAgreement-' + item.id} value={item.id}>
                                                {is_provider
                                                    ? `${item.id}: ${item.ext_id} ${item.description} — ${item.customer.id}: ${item.customer.ext_id} ${item.customer.name}`
                                                    : `${item.id}: ${item.ext_id} ${item.description} — ${item.provider.id}: ${item.provider.ext_id} ${item.provider.name}`
                                                }
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={2} xs={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Fecha de Entrega</Form.Label>
                                    <Form.Control
                                        required disabled={readonly}
                                        type="date" value={deliveryDate}
                                        onChange={(e) => setDeliveryDate(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={2} xs={6}>
                                <Form.Group className="mb-1">
                                    <Form.Label>Hora de Entrega</Form.Label>
                                    <Form.Control
                                        disabled={readonly}
                                        type="time" value={deliveryTime}
                                        onChange={(e) => setDeliveryTime(e.target.value)}
                                    />
                                </Form.Group>
                                {/* Indicador de plazo */}
                                {!readonly && hoursValid && (
                                    <div style={{ fontSize: 11, marginTop: 4, fontWeight: 600, color: deadlineOk ? '#16a34a' : '#dc2626' }}>
                                        <i className="fa fa-clock-o" style={{ marginRight: 3 }} />
                                        {deadlineOk
                                            ? `${Math.floor(hoursLeft)}h disponibles`
                                            : `Mín. ${minHoursDeliver}h — faltan ${Math.ceil(minHoursDeliver - hoursLeft)}h`
                                        }
                                    </div>
                                )}
                                {!readonly && agreement && !deliveryDate && (
                                    <div style={{ fontSize: 11, color: 'var(--abi-muted)', marginTop: 4 }}>
                                        <i className="fa fa-info-circle" style={{ marginRight: 3 }} />
                                        Plazo mínimo: {minHoursDeliver}h
                                    </div>
                                )}
                            </Col>
                        </Row>
                        {orderId && roles.includes('customer_admin') && (
                            <Row>
                                <Col md={3} xs={12}>
                                    <Form.Group className="mb-0">
                                        <Form.Label>Nueva Fecha de Creación</Form.Label>
                                        <Form.Control
                                            disabled={readonly} type="date"
                                            value={newCreatedAt}
                                            onChange={(e) => setNewCreatedAt(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        )}
                    </div>
                </div>

                {/* ── Sección 2: Fondo ── */}
                <div className="order-section">
                    <div className="order-section-header">
                        <i className="fa fa-money" /> Fondo presupuestal
                        {!readonly && <SectionDot ok={done.fund} />}
                    </div>
                    <div className="order-section-body">
                        {!readonly && !agreement && (
                            <div style={{ fontSize: 13, color: 'var(--abi-muted)', marginBottom: 10, display: 'flex', alignItems: 'center', gap: 6 }}>
                                <i className="fa fa-arrow-up" /> Selecciona primero un contrato para ver los fondos disponibles.
                            </div>
                        )}
                        <Row>
                            <Col md={8} xs={12}>
                                <Form.Group className="mb-2">
                                    <Form.Label>Fondo</Form.Label>
                                    <Form.Select
                                        disabled={readonly || orderId || !agreement}
                                        value={fund}
                                        onChange={(e) => {
                                            setFund(e.target.value);
                                            const available = e.target.options[e.target.selectedIndex].getAttribute('available');
                                            setInitFundVal((parseFloat(available) + (orderId ? totalOrder : 0)) || 0);
                                        }}
                                    >
                                        <option value="">— Selecciona un fondo —</option>
                                        {funds && funds.map(item => (
                                            item.agreement_id == agreement &&
                                            <option
                                                key={'fund' + item.id}
                                                value={item.id}
                                                available={parseFloat(item.available)}
                                                disabled={!item.is_active}
                                            >
                                                {item.id}:{item.ext_id} {item.name}
                                                {!orderId ? ' — disponible: ' + currencyFormater(item.available) : ''}
                                                {!item.is_active ? ' — Inactivo' : ''}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            {fund && initFundVal !== null && (
                                <Col md={4} xs={12}>
                                    <div className="fund-summary-card">
                                        <div className="fund-summary-row">
                                            <span>Presupuesto</span>
                                            <strong>{currencyFormater(initFundVal)}</strong>
                                        </div>
                                        <div className="fund-summary-row">
                                            <span>Pedido</span>
                                            <strong>{currencyFormater(totalOrder)}</strong>
                                        </div>
                                        <div className="fund-summary-row">
                                            <span>Disponible</span>
                                            <strong style={{ color: orderFundVal < 0 ? C.danger : C.success }}>
                                                {currencyFormater(orderFundVal)}
                                            </strong>
                                        </div>
                                        <div className="fund-bar-wrap" style={{ marginTop: 8 }}>
                                            <div className="fund-bar-fill" style={{ width: `${fundUsedPct}%`, background: fundBarColor }} />
                                        </div>
                                        <div style={{ fontSize: 11, color: '#64748b', marginTop: 4, textAlign: 'right' }}>
                                            {fundUsedPct.toFixed(0)}% utilizado
                                        </div>
                                    </div>
                                </Col>
                            )}
                        </Row>
                    </div>
                </div>

                {/* ── Sección 3: Datos de entrega ── */}
                <div className="order-section">
                    <div className="order-section-header">
                        <i className="fa fa-map-marker" /> Datos de Entrega
                        {!readonly && <SectionDot ok={done.delivery} />}
                    </div>
                    <div className="order-section-body">
                        <Row>
                            <Col md={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Dirección de entrega</Form.Label>
                                    <Form.Control
                                        disabled={readonly} type="text"
                                        value={deliveryAddress}
                                        placeholder="Ej: Calle 123 #45-67, Edificio X, Piso 3"
                                        onChange={(e) => setDeliveryAddress(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Evento <span style={{ fontWeight: 400, color: 'var(--abi-muted)', fontSize: 12 }}>(opcional)</span></Form.Label>
                                    <Form.Control
                                        disabled={readonly} type="text"
                                        value={deliveryEvent}
                                        placeholder="Ej: Reunión de directivos"
                                        onChange={(e) => setDeliveryEvent(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Ciudad</Form.Label>
                                    <Form.Select
                                        disabled={readonly}
                                        value={cityId}
                                        onChange={(e) => {
                                            setCityId(e.target.value);
                                            setSubLocalityId('');
                                        }}
                                    >
                                        <option value="">— Selecciona una ciudad —</option>
                                        {KNOWN_CITIES.map(c => (
                                            <option key={c.id} value={c.id}>{c.name}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={8} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        {subLocalityLabel}
                                        {' '}<span style={{ fontWeight: 400, color: 'var(--abi-muted)', fontSize: 12 }}>(opcional)</span>
                                    </Form.Label>
                                    <Form.Select
                                        disabled={readonly || !cityId || loadingSubLocalities}
                                        value={subLocalityId}
                                        onChange={(e) => setSubLocalityId(e.target.value)}
                                    >
                                        <option value="">
                                            {!cityId
                                                ? '— Selecciona primero una ciudad —'
                                                : loadingSubLocalities
                                                    ? 'Cargando…'
                                                    : `— Selecciona ${subLocalityLabel} —`
                                            }
                                        </option>
                                        {subLocalities.map(s => (
                                            <option key={s.id} value={s.id}>{s.name}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Persona que recibe</Form.Label>
                                    <Form.Control
                                        disabled={readonly} type="text"
                                        value={personReceiving}
                                        placeholder="Nombre completo"
                                        onChange={(e) => setPersonReceiving(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Teléfono</Form.Label>
                                    <Form.Control
                                        disabled={readonly} type="tel"
                                        value={personReceivingPhone}
                                        placeholder="Ej: 3001234567"
                                        onChange={(e) => setPersonReceivingPhone(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                </div>

                {/* ── Sección 4: Notas ── */}
                <div className="order-section">
                    <div className="order-section-header">
                        <i className="fa fa-sticky-note-o" /> Notas
                        <span style={{ marginLeft: 'auto', fontSize: 11, fontWeight: 400, color: 'var(--abi-muted)', textTransform: 'none', letterSpacing: 0 }}>
                            opcional
                        </span>
                    </div>
                    <div className="order-section-body">
                        <Form.Control
                            disabled={readonly} as="textarea" rows={2}
                            value={notes}
                            maxLength={400}
                            onChange={(e) => setNotes(e.target.value)}
                            placeholder="Observaciones o instrucciones adicionales para la entrega…"
                        />
                        {!readonly && (
                            <div style={{ fontSize: 11, color: 'var(--abi-muted)', textAlign: 'right', marginTop: 4 }}>
                                {(notes || '').length}/400
                            </div>
                        )}
                    </div>
                </div>
            </Form>

            {/* ── Productos ── */}
            <div className="order-section">
                <div className="order-section-header" style={{ justifyContent: 'space-between' }}>
                    <span>
                        <i className="fa fa-shopping-basket" /> Productos del pedido
                        {details.length > 0 && (
                            <span style={{ marginLeft: 8, background: 'var(--abi-primary)', color: '#fff', borderRadius: 999, fontSize: 10, fontWeight: 700, padding: '1px 7px' }}>
                                {details.length}
                            </span>
                        )}
                        {!readonly && <SectionDot ok={done.products} />}
                    </span>
                    {!readonly && (
                        <span title={!agreement ? 'Selecciona primero un contrato' : ''}>
                            <Button
                                size="sm" variant="primary"
                                onClick={() => setShowProductsModal(true)}
                                disabled={!agreement}
                            >
                                <i className="fa fa-plus" /> Agregar productos
                            </Button>
                        </span>
                    )}
                </div>
                <div className="order-section-body" style={{ padding: details.length ? '0' : '24px 16px' }}>
                    {!details.length && (
                        <div style={{ textAlign: 'center', color: 'var(--abi-muted)', padding: '8px 0 4px' }}>
                            <i className="fa fa-shopping-basket" style={{ fontSize: 28, opacity: 0.25, display: 'block', marginBottom: 10 }} />
                            <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 4 }}>Sin productos</div>
                            <div style={{ fontSize: 13 }}>
                                {!agreement
                                    ? 'Selecciona un contrato para habilitar el catálogo de productos.'
                                    : 'Usa el botón "Agregar productos" para buscar y añadir ítems al pedido.'
                                }
                            </div>
                        </div>
                    )}
                    <OrderDetails
                        setTotalOrder={setTotalOrder} totalOrder={totalOrder}
                        products={details} setProducts={setDetails} readonly={readonly}
                        setItemsToDelete={setItemsToDelete} itemsToDelete={itemsToDelete}
                    />
                </div>
            </div>

            {/* ── Footer de acciones ── */}
            {!readonly && (
                <div className="order-form-footer">
                    {message && <Alert variant={messageType || 'warning'} className="mb-3">{message}</Alert>}
                    <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                        <Button as={Link} to="/products" variant="outline-secondary">
                            <i className="fa fa-arrow-left" /> Volver
                        </Button>
                        <Button variant="primary" onClick={saveOrder} disabled={!!message}>
                            <i className={orderId ? 'fa fa-save' : 'fa fa-check'} />
                            {' '}{orderId ? 'Guardar cambios' : 'Crear pedido'}
                        </Button>
                    </div>
                </div>
            )}

            {/* ── Modal catálogo ── */}
            <Modal show={showProductsModal} fullscreen onHide={() => setShowProductsModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Agregar Productos al Pedido</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Catalog
                        isCreatingOrder
                        addProduct={addProduct}
                        agreement={agreement}
                        productSel={preselectedProduct}
                        setProductSel={setPreselectedProduct}
                    />
                </Modal.Body>
            </Modal>

            <AlertModal
                show={alertModalShow} setShow={setAlertModalShow}
                msg={alertModalMsg} setMsg={setAlertModalMsg}
                onConfirm={alertModalOnConfirm} setOnConfirm={setAlertModalOnConfirm}
                onClose={alertModalOnClose} setOnClose={setAlertModalOnClose}
                variant={alertModalType}
            />
            <Print show={showPrint} setShow={setShowPrint} idPrint={idPrint} setIdPrint={setIdPrint} />
        </>
    );
}

function mapStateToProps(state) {
    return {
        isLoading: state.isLoading,
        roles: state.roles,
        is_provider: state.is_provider,
        organization: state.organization,
    };
}

const mapDispatchToProps = { setIsLoading };

export default connect(mapStateToProps, mapDispatchToProps)(OrderCreate);
